import { actionCreator } from './_actionCreator';

export const SET_LANG = "SET_LANG";

export const setLang = actionCreator(SET_LANG);

const initialState = "es";

const reducer = function(state = initialState, action){
	switch(action.type){
		case SET_LANG:
			return action.payload;
		default:
			return state;
	}
};

export const lang = {persist : true, reducer};